import { Http } from "app/Http/Http";
import { IList } from "shared/types/commonTypes";
import { ISpv } from "./types";

export const dealsApi = {
  getSpvs: () => {
    return Http.get<IList<ISpv>>(`/admin/spv`);
  },
};
